import { render, staticRenderFns } from "./DetailReport.vue?vue&type=template&id=47bdf756&scoped=true"
import script from "./DetailReport.vue?vue&type=script&lang=js"
export * from "./DetailReport.vue?vue&type=script&lang=js"
import style0 from "./DetailReport.vue?vue&type=style&index=0&id=47bdf756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bdf756",
  null
  
)

export default component.exports